import styled, { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  *, *::after, *::before {
    margin: 0px;
    padding: 0px;
    box-sizing: inherit;
    word-break: keep-all !important;
    font-family: 'Ubuntu', sans-serif;

    @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,400,700&display=swap');

    text-align: center;
  }

  html,
  body,
  * {
    font-family: 'Ubuntu', sans-serif;
  }

  body {
    margin: 0;
  }
`

export const AppContainer = styled.div`
  @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,400,700&display=swap');

  text-align: center;

  html,
  body,
  * {
    font-family: 'Ubuntu', sans-serif;
    box-sizing: border-box;
  }

  th,
  td {
    vertical-align: middle !important;
  }
`
export const SimulationNumberMain = styled.div`
  font-family: Ubuntu;
  color: #9f9f9f;
  font-size: 16px;
  padding: 10px 0;
  text-align: center;
`
export const MainContainer = styled.div`
  max-width: calc(1440px - 32px);
  padding: 0 24px;
  width: 100%;
  margin: auto;
`
